/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listMutualGroups.defs'
export { main as default } from './listMutualGroups.defs'
